import { invoke } from "@tauri-apps/api/core";
import { releaseScreenRecordingSession } from "./screen-recording-store";
import { emit } from "@tauri-apps/api/event";

import { useActiveDisplay } from "./use-active-display";
import {
  beginVoiceAttentionSession,
  clearVoiceAttentionSession,
  useVoiceAttentionStore,
  voiceAttentionElapsedMs,
  setVoiceAttentionOrigin,
  type VoiceAttentionState,
} from "./voice-attention-store";
import {
  VOICE_ATTENTION_CLEAR_EVENT,
  VOICE_ATTENTION_SESSION_EVENT,
} from "./use-voice-attention";
import { clearVoiceAttentionChapterCaptures } from "./voice-attention-chapter-capture";

export function startVoiceAttentionSession(): string {
  const recordingId = crypto.randomUUID();
  const cursor = useActiveDisplay.getState();
  const activation = {
    display_id: cursor.activeDisplayId,
    x: cursor.cursorX,
    y: cursor.cursorY,
    source: "speak" as const,
  };
  beginVoiceAttentionSession(recordingId, activation);
  void emit(VOICE_ATTENTION_SESSION_EVENT, {
    recordingId,
    activation,
  }).catch(() => {});
  return recordingId;
}

export function clearVoiceAttentionSessionEverywhere(
  recordingId: string | null,
): void {
  if (recordingId) {
    releaseScreenRecordingSession(recordingId);
    clearVoiceAttentionChapterCaptures(recordingId);
    if (useVoiceAttentionStore.getState().recordingId === recordingId) {
      clearVoiceAttentionSession();
    }
    void emit(VOICE_ATTENTION_CLEAR_EVENT, { recordingId }).catch(() => {});
  }
}

export function voiceAttentionOriginDisplayId(): number | null {
  return (
    useVoiceAttentionStore.getState().activation?.display_id ??
    useActiveDisplay.getState().activeDisplayId
  );
}

export function voiceAttentionNativeActivation(recordingId: string) {
  return {
    active: true,
    recordingId,
    attentionElapsedMs: voiceAttentionElapsedMs(),
  };
}

export async function activateVoiceAttentionNative(
  recordingId: string,
  target?: VoiceAttentionState,
): Promise<number | null> {
  const origin = await invoke<number | null>(
    "set_voice_active",
    voiceAttentionNativeActivation(recordingId),
  );
  if (origin !== null) setVoiceAttentionOrigin(recordingId, origin, target);
  return origin;
}
